type QuinnPanelResizeHandleProps = {
    isResizing: boolean;
    onPointerDown: (event: React.PointerEvent<HTMLDivElement>) => void;
};

export function QuinnPanelResizeHandle({ isResizing, onPointerDown }: QuinnPanelResizeHandleProps) {
    return (
        <div
            onPointerDown={onPointerDown}
            className="group absolute inset-y-0 left-0 z-10 w-2 cursor-col-resize touch-none"
            role="separator"
            aria-orientation="vertical"
            aria-label="Paneelbreedte aanpassen"
        >
            <span
                className={`absolute left-[3px] top-1/2 h-10 w-[3px] -translate-y-1/2 rounded-full transition-colors ${
                    isResizing ? "bg-primary" : "bg-gray-200 group-hover:bg-primary/50"
                }`}
            />
        </div>
    );
}
